<div class="task-screen-element" *ngIf="!hideTimer">
  <div class="timer-bar-empty"></div>
  <div #timerBar class="timer-bar-colored" [ngStyle]="{'width': filledWidth + '%'}"></div>
  <div #timerBox class="timer-counter-box font-24" [ngStyle]="{'background': ' ' + darkContainerColor, 'color': '#000000', 'border-color': ' ' + taskBarColor}"
    [ngClass]="{ 'timer-counter-box-blink' : highlight }">
    <p id="timer-points" [ngClass]="{'float-up': floatPointsUp}">{{currentPointTotal}}</p>
  </div>
</div>